module.exports = __webpack_public_path__ + "static/img/famous-teacher-studio.2759a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/famous-teacher-studio.png
// module id = xpzL
// module chunks = 1